//style imports
import "./praiseSection.scss";

export default function PraiseSection() {
    const praiseQuotes = [
        {
            quote: "Tao's debut is an intricate study of court politics and what a young woman will do to survive.",
            source: "Library Journal, starred review"
        },
        {
            quote: "The many political threads become fascinatingly tangled, Tao's prose gleams with poetic precision, and climactic revelations strike with devastating inevitability.",
            source: "Publisher's Weekly, starred review"
        },
        {
            quote: "Resilient and clever, Wei is the heart of the novel, striving to navigate a world of lies and cruelty without becoming cruel herself. She learns to wield power with fidelity to her purpose, and though the novel's title alludes to her triumph, the story is full of page-turning suspense.",
            source: "Kirkus Review"
        },
        {
            quote: "With political intrigue as sharp as a blade and sweeping, ethereal prose, The Poet Empress is an astounding debut novel. This mesmerising fantasy shattered and healed my heart in equal measure―and I enjoyed every moment of it.",
            source: "Chelsea Abdullah, author of The Stardust Thief"
        },
        {
            quote: "The very definition of an epic. The Poet Empress draws its world with sharp clarity, its characters with astounding depth, and its magic with flawless precision. Vicious, gorgeous, and fiercely haunting until the end.",
            source: "Chloe Gong, New York Times bestselling author of Immortal Longings"
        },
        {
            quote: "A beautifully devastating tale, powerfully and elegantly told – The Poet Empress will cut you and heal you all at once. This is not a love story, but it is a story about love, and all the ugly things that fill the void when it's taken away. With an unflinching eye and a poet's quiet restraint, Tao weaves power, pain, hope, and humanity together into an epic tapestry that will take your breath away.",
            source: "Julie Leong, bestselling author of The Teller of Small Fortunes"
        },
        {
            quote: "The Poet Empress is a hidden knife, one that cuts so deeply and cleanly that it excises your heart and makes you like it. I have rarely had such a breathless reading experience, where each page reveals the ways in which humanity's beauty and ugliness run lockstep with one another. Terrifying and enthralling!",
            source: "Andrea Stewart, author of The Bone Shard Daughter"
        },
        {
            quote: "The Poet Empress will surprise you. It will, at times, terrify you. But Tao's rich tale is multifaceted―it is brutal, yes, but also beautiful and full of hope and kindnesses both big and small. If you love court intrigue, creative magic systems, and protagonists who know that empathy is a strength and not a weakness, even as they are forced to make impossible decisions, this is the book for you.",
            source: "Kemi Ashing-Giwa, USA Today bestselling author of The Splinter in the Sky"
        },
        {
            quote: "Taut, sharp, and compelling. With haunting prose and characters vividly real, The Poet Empress is a devastating composition, revealing intrigue, magic, and politics turn by thrilling turn. Impeccably paced, vicious and romantic, this is a deadly debut that'll have you at the edge of your seat.",
            source: "Kritika H. Rao, author of The Surviving Sky"
        },
        {
            quote: "Sublime. Against a lush, poetic rendition of ancient China, Tao unfurls a breathlessly sweeping and brutally romantic historical epic woven with themes of feminism, courage, and morality. Powerful and poignant, THE POET EMPRESS is one of my favorite recent reading experiences.",
            source: "Amélie Wen Zhao, New York Times and #1 Sunday Times bestselling author of The Scorpion and the Night Blossom"
        },
        {
            quote: "There are many stories about the power of words, but none quite like this: an illiterate girl learns to write poetry that changes the world. And yet, no simple words can do justice to this book's beating heart--its intimate portrayal of characters so painfully human that you see them as real people, flawed, traumatized, and still yearning for love. From the very first page, this book had me completely gripped. The Poet Empress is fantasy at its best.",
            source: "Vaishnavi Patel, New York Times bestselling author of Kaikeyi"
        },
        {
            quote: "Lyrical, romantic, and full of heart, The Poet Empress is an epic fantasy debut that captivates from the very first page.",
            source: "K. X. Song, New York Times bestselling author of The Night Ends with Fire"
        },
        {
            quote: "This dark fantasy stands out among the plethora of romantasy books with its strong characters and unique setting.",
            source: "Booklist"
        }
    ];

    return (
        <section className="praise">
            <h3 className="praise__title">Praise for The Poet Empress</h3>
            <div className="praise__quotes">
                {praiseQuotes.map((item, index) => (
                    <div key={index} className="praise__quote-container">
                        <blockquote className="praise__quote">
                            "{item.quote}"
                        </blockquote>
                        <cite className="praise__source">—{item.source}</cite>
                    </div>
                ))}
            </div>
        </section>
    )
}